import {
  FETCH_PARTNER_ORDERS,
  FETCH_PARTNER_ORDERS_SUCCESS,
  FETCH_PARTNER_ORDERS_FAILED,
  CREATE_PARTNER_ORDER,
  CREATE_PARTNER_ORDER_SUCCESS,
  CREATE_PARTNER_ORDER_FAILED,
  UPDATE_PARTNER_ORDER_STATUS,
  CLEAR_PARTNER_ORDER,
} from '../store/types';

const INITIAL_STATE = {
  orders: null,
  current: null,
  lastCreatedId: null,
  loading: false,
  error: { flag: false, msg: null },
};

export const partnerorderreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PARTNER_ORDERS:
      return { ...state, loading: true };
    case FETCH_PARTNER_ORDERS_SUCCESS:
      return {
        ...state,
        orders: action.payload,
        loading: false,
        error: { flag: false, msg: null },
      };
    case FETCH_PARTNER_ORDERS_FAILED:
      return {
        ...state,
        orders: null,
        loading: false,
        error: { flag: true, msg: action.payload },
      };
    case CREATE_PARTNER_ORDER:
      return { ...state, loading: true, current: action.payload };
    case CREATE_PARTNER_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        lastCreatedId: action.payload?.orderId || null,
        current: action.payload?.order || state.current,
        error: { flag: false, msg: null },
      };
    case CREATE_PARTNER_ORDER_FAILED:
      return {
        ...state,
        loading: false,
        error: { flag: true, msg: action.payload },
      };
    case UPDATE_PARTNER_ORDER_STATUS:
      return state;
    case CLEAR_PARTNER_ORDER:
      return { ...state, current: null };
    default:
      return state;
  }
};
